//messages.js
export default {
    currency_id: "Currency",
    code: "Code",
    name: "Name",
    prefix: "Prefix",
    suffix: "Suffix",
    precision: "Precision",
    decimal_sep: "Decimal Separator",
    thousands_sep: "Thousands Separator",
    mask: "Input Mask",
    edit_currency: "Edit Currency",
    add_currency: "Add Currency",
    delete_currency: "Delete Currency",
    currencies: "Currencies",

    exchange_rate_id: "Exchange Currency",
    from_currency_id: "Base Currency",
    to_currency_id: "To Currency",
    rate: "Rate",
    edit_exchange_rate: "Edit Exchange Rate",
    add_exchange_rate: "Add Exchange Rate",
    delete_exchange_rate: "Delete Exchange Rate",
    exchange_rates: "Exchange Rates",
};
